export enum VideoIdentifier {
  FINANCIAL_ADVISOR_ACTIVE_FILES_EMPTY_STATE = 'financial-advisor-active-files-empty-state',
  FINANCIAL_ADVISOR_PRO_UPSELL_INTRO_VIDEO = 'financial-advisor-pro-upsell-intro-video',
  CONQUEST_PLAN_DATA_SUMMARY = 'conquest-plan-data-summary'
}
